






import { Vue, Component, Prop, Inject } from "vue-property-decorator";

@Component
export default class CommonTab extends Vue {
  @Prop({ required: true }) tabTitle!: string;
  @Prop({ default: true }) showTab!: boolean;

  active = false;

  @Inject("registerTab") readonly registerTab!: (tab: CommonTab) => void;

  mounted () {
    if (this.showTab && this.registerTab) {
      this.registerTab(this);
    }
  }
}
